


































import { Component, Vue, Ref } from "vue-property-decorator";
import BaseDialogComponent from "@/components/common/BaseDialog.vue";
import { LicenceInfoV3 } from "@/data/models/LicenceInfoV3";

interface LicenceUsageItem {
  showError: boolean;
  showUsage: boolean;
  label: string;
  usage: string;
}

@Component({
  components: {
    "base-dialog": BaseDialogComponent,
  },
})
export default class LicenceUsageDetailsComponent extends Vue {
  @Ref("baseDialog")
  baseDialogComponent!: BaseDialogComponent;

  resolve?: (value: boolean) => void = undefined;
  reject?: (reason: string) => void = undefined;

  items: LicenceUsageItem[] = [];
  hasError = false;

  isShowingLicencesOverviewOfMemberClients = false;

  /** Text colour of the rows, readable on the light and the dark dialog background. */
  get textColorClass() {
    return this.$vuetify.theme.dark ? "dark-text--text" : "black--text";
  }

  getUsageStyle(item: LicenceUsageItem) {
    return item.showError ? "color: red" : "";
  }

  get numColsForLabel() {
    return this.isShowingLicencesOverviewOfMemberClients
      ? 5
      : 4;
  }

  async show(
    licenceInfoV3: LicenceInfoV3, 
    licenceInfoV3OfGroup?: LicenceInfoV3[], 
    numberOfMemberClientsForLicenceInfoV3?: number
  ) {
    this.hasError = false;
    this.isShowingLicencesOverviewOfMemberClients = licenceInfoV3OfGroup !== undefined &&
      numberOfMemberClientsForLicenceInfoV3 !== undefined;

    this.baseDialogComponent.show({
      title: this.$t("assignLicences.overviewUsedLicences").toString(),
      positiveButtonText: this.$t("common.ok").toString(),
      negativeButtonText: null,
      closeOnSave: false,
      persistent: true,
    });

    this.buildItems(
      licenceInfoV3,
      licenceInfoV3OfGroup,
      numberOfMemberClientsForLicenceInfoV3
    );

    return new Promise<boolean>((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }

  onClose() {
    this.baseDialogComponent.isShowing = false;
  }

  private buildItems(
    licenceInfoV3: LicenceInfoV3, 
    licenceInfoV3OfGroup?: LicenceInfoV3[], 
    numberOfMemberClientsForLicenceInfoV3?: number
  ) {
    if (licenceInfoV3OfGroup && numberOfMemberClientsForLicenceInfoV3) {
      this.items = [
        {
          showError: false,
          showUsage: true,
          label: this.$t(`assignLicences.numMemberClients`).toString(),
          usage: this.$t("assignLicences.formatUsageMemberClients", [numberOfMemberClientsForLicenceInfoV3]).toString()
        },
        this.buildLicenceInfoItemForGroup(licenceInfoV3OfGroup, "basic"),
        this.buildLicenceInfoItemForGroup(
          licenceInfoV3OfGroup,
          "damageAssessmentAndLeakDetection"
        ),
        this.buildLicenceInfoItemForGroup(licenceInfoV3OfGroup, "dryingAndRepair"),
      ].filter((item) => item.showUsage);
    }
    else {
      this.items = [
        this.buildLicenceInfoItem(licenceInfoV3, "basic"),
        this.buildLicenceInfoItem(
          licenceInfoV3,
          "damageAssessmentAndLeakDetection"
        ),
        this.buildLicenceInfoItem(licenceInfoV3, "dryingAndRepair"),
      ].filter((item) => item.showUsage);
    }
    
  }

  private buildLicenceInfoItemForGroup(
    licenceInfoV3: LicenceInfoV3[],
    fieldName: "basic" | "damageAssessmentAndLeakDetection" | "dryingAndRepair"
  ): LicenceUsageItem {
    let numLicencesUsed = 0;
    let numLicencesAssigned = 0;

    licenceInfoV3.forEach((licenceInfo) => {
      numLicencesUsed += licenceInfo.usedLicences[fieldName];
      numLicencesAssigned += licenceInfo.assignedLicences[fieldName];
    });

    const showError = numLicencesUsed > numLicencesAssigned;
    const alwaysShowLicenceUsage = fieldName === "basic";

    if (showError) {
      this.hasError = true;
    }

    return {
      showError,
      showUsage:
        alwaysShowLicenceUsage || numLicencesUsed + numLicencesAssigned > 0,
      label: this.$t(`assignLicences.${fieldName}Licences`).toString(),
      usage: this.$t("assignLicences.formatUsageMemberClients", [
        numLicencesUsed,
      ]).toString(),
    };
  }

  private buildLicenceInfoItem(
    licenceInfoV3: LicenceInfoV3,
    fieldName: "basic" | "damageAssessmentAndLeakDetection" | "dryingAndRepair"
  ): LicenceUsageItem {
    const numLicencesUsed = licenceInfoV3.usedLicences[fieldName];
    const numLicencesAssigned = licenceInfoV3.assignedLicences[fieldName];

    const showError = numLicencesUsed > numLicencesAssigned;
    const alwaysShowLicenceUsage = fieldName === "basic";

    if (showError) {
      this.hasError = true;
    }

    return {
      showError,
      showUsage:
        alwaysShowLicenceUsage || numLicencesUsed + numLicencesAssigned > 0,
      label: this.$t(`assignLicences.${fieldName}`).toString(),
      usage: this.$t("assignLicences.formatUsage", [
        numLicencesUsed,
        numLicencesAssigned,
      ]).toString(),
    };
  }
}
